var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDolly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12564_28720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8444 30.2637C55.3006 28.6279 53.5412 27.7334 51.9089 28.2881L32.2214 34.8809C33.4542 36.4648 34.2222 38.4473 34.2222 40.625C34.2222 40.6851 34.2055 40.7408 34.2044 40.8007L53.8724 34.2147C55.5042 33.6719 56.3014 31.8945 55.8444 30.2637ZM10.1986 0H3.11111C1.39319 0 0 1.39941 0 3.125C0 4.85059 1.39319 6.25 3.11111 6.25H10.2025L19.1683 33.2715C20.7569 32.0215 22.7208 31.25 24.8889 31.25C24.9485 31.25 25.0034 31.2664 25.0628 31.2675L16.1097 4.27246C15.2542 1.7168 12.8819 0 10.1986 0ZM39.5403 15.3223L36.3222 5.61523L30.4111 7.58105L33.6321 17.2861L39.5403 15.3223Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.089 22.3066L44.2168 4.6162C43.9494 3.78612 43.0627 3.34667 42.2607 3.62792L36.3223 5.61718L39.5423 15.3223L33.6361 17.2871L30.4112 7.583L24.4204 9.58495C23.6061 9.85351 23.1691 10.7451 23.4484 11.5498L28.5136 27.126C30.2636 27.6143 31.8795 28.4326 33.3261 29.5303L49.0275 24.2812C49.9334 24.0059 50.3709 23.1269 50.089 22.3066ZM24.889 31.252C19.6487 31.252 15.5557 35.3633 15.5557 40.627C15.5557 45.8906 19.7343 50.002 24.889 50.002C30.0437 50.002 34.2223 45.8047 34.2223 40.627C34.2223 35.4492 30.0418 31.252 24.889 31.252ZM24.889 43.752C23.1711 43.752 21.7779 42.3525 21.7779 40.627C21.7779 38.9014 23.1711 37.5898 24.889 37.5898C26.6069 37.5898 28.0001 38.8984 28.0001 40.627C28.0001 42.3555 26.6098 43.752 24.889 43.752Z",
    fill: "#00A2C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12564_28720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolly);
export default __webpack_public_path__ + "static/media/dolly.cf607333c7f143f30eea83d12829cf4c.svg";
export { ForwardRef as ReactComponent };